import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PmdRadioButton } from './radio.component';

export { PmdRadioValueAccessor, PmdRadioButton } from './radio.component';

@NgModule({
  declarations: [
    PmdRadioButton
  ],
  exports: [
    PmdRadioButton
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class PmdRadioButtonModule { }
